<template>
  <div v-if="discount !== undefined && discount !== null && discount !== ''">
    <!-- <div
      class="bus-label"
      v-if="showType === 'recommend'"
    >
      <div class="bus-label-price">
        <div class="marketing-price">
          <div class="left-icon left-icon-discount">
            <span class="discount-text" v-if="discountTagShow">{{ discount }}{{ TLang("折", "sxChange") }}</span>
          </div>
          <div class="discount-price">
            <span class="discount-text" v-if="discountPrice">{{ getStrPrice(discountPrice, unionScale) }}</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="bus-detail-label">
      <!-- <div class="price"> -->
        <img :src="unionIcon" class="fudou" alt="fudou" :style="{ flexShrink: '0' }" />
        <span class="bus-detail-label-price">{{ getStrPrice(discountPrice, unionScale) }}</span>
      <!-- </div> -->
      <!-- <div
        class="single-discount"
        v-if="discountTagShow === 1 && mktTagShow == 1"
      >
        {{ discount }}<span>{{ TLang("折", "sxChange") }}</span>
      </div> -->
      <div :style="{ flexShrink: '0' }">
        <div
          class="marketing-price"
        >
          <div class="left-icon left-icon-discount">
            <span class="icon">
              <svg width="8px" height="8px" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="一品多价-页面" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="标签实现方式" transform="translate(-85.000000, -187.000000)" fill="#F6D99A">
                        <g id="企业专享价V" transform="translate(85.000000, 187.000000)">
                            <polygon id="路径备份" points="8 0.0035294222 5.133456 0 2.292496 3.85716044 2.292496 0.668259555 2.292496 0.608491516 2.292496 0.0035294222 0 0.0035294222 0 0.668259555 0.573703997 0.668259555 0.573703997 8 2.292496 8"></polygon>
                        </g>
                    </g>
                </g>
            </svg>
            </span>
            <span class="discount-text" v-if="mktTagShow === 1 && showType != 'recommend'">{{ TLang('专享价', 'result') }}</span>
            <span class="discount-text" v-if="discountTagShow === 1">{{ discount }}{{ TLang("折", "sxChange") }}</span>
          </div>
        </div>
      </div>
      <!-- <div
        class="not-tag"
        v-if="
          !discountTagShow &&
          !mktTagShow &&
          discount !== null &&
          discount !== undefined
        "
      >
        <img src="../assets/imgs/10@2x.png" />
      </div> -->
    </div>
  </div>
</template>

<script>
import fudou from "../assets/imgs/fudou.png";
import { replacePrice } from "../utils";
export default {
  components: {},
  props: {
    showType: {
      type: String,
      default: "",
    },
    discountPrice: {
      type: Number,
      default: null,
    },
    discount: {
      type: String,
      default: "",
    },
    discountTagShow: {
      type: Number,
      default: 0,
    },
    mktTagShow: {
      type: Number,
      default: 0,
    },
    noText: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unionIcon: window.union_icon || fudou,
      unionScale: window.union_scale || 1,
    };
  },
  computed: {},
  methods: {
    getStrPrice(str, unionScale) {
      const v = replacePrice(str, unionScale);
      if (v !== undefined && v !== null) {
        return parseFloat(parseFloat(v).toFixed(2));
      } else {
        return "";
      }
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
@375: 320/375;
.bus-detail-label {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: 18px * @375;
  overflow-y: hidden;
  margin-bottom: 2px * @375;
  & > img {
    width: 12px * @375;
    height: 12px * @375;
    vertical-align: middle;
  }
  &-price {
    display: block;
    max-width: calc(100% - 13px * @375);
    font-weight: 600;
    font-size: 18px * @375;
    color: #333333;
    line-height: 18px * @375;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

.recommend-list .bus-label {
  margin-bottom: 2px * @375;
}
.marketing-price {
  font-size: 10px * @375;
  & > .left-icon {
    height: 14px * @375;
    line-height: initial  ;
    z-index: 11;
    position: relative;
    background: #333;
    & >.icon {
      display: block;
      width: 8px * @375;
      height: 8px * @375;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    & > .discount-text {
      // display: -webkit-box !important;
      padding-top: 1px * @375;
      line-height: 1;
      font-weight: 400;
      font-size: 10px* @375;
      color: #ECC87E;
      // margin-right: 4px * @375;
      // box-sizing: border-box;
    }
  }
  // & > .left-icon::after {
  //   content: "";
  //   position: absolute;
  //   background-image: url("../assets/imgs/jt_new.png");
  //   background-repeat: no-repeat;
  //   background-size: 100% 100%;
  //   right: -3px * @375;
  //   width: 4px * @375;
  //   height: 14px * @375;
  //   top: 0;
  // }

  /**  左侧标记 **/
  & > .left-icon-discount {
    border-radius: 2px * @375;
    overflow: hidden;
    height: 14px * @375;
    min-width: 12px;
    text-align: left;
    background-size: 100%;
    padding-left: 2px * @375;
    padding-right: 2px * @375;
    position: relative;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
  // & > .left-icon-discount::before {
  //   content: "";
  //   background: url("../assets/imgs/v_new.png") no-repeat center;
  //   background-size: 100% auto;
  //   position: absolute;
  //   width: 8px * @375;
  //   height: 8px * @375;
  //   left: 2px * @375;
  //   top: 3px * @375;
  // }
  /**  促销价格 **/
  & > .discount-price {
    height: 14px * @375;
    font-size: 12px * @375;
    font-weight: 400;
    padding-right: 4px * @375;
    padding-left: 4px * @375;
    color: #333;
    background: #E8C172;
    position: relative;
    display: flex;
    align-items: center;
    & > span {
      padding: 1px * @375 0 1px * @375 0;
      height: 14px * @375;
      display: -webkit-box !important;
      font-size: 12px * @375;
      box-sizing: border-box;
    }
    & > .tips {
      // height: 14px * @375;
      // line-height: 15px * @375;
      font-size: 12px * @375;
      font-weight: 400;
      color: #333;
      margin-left: 2px * @375;
      // display: flex;
      // align-items: center;
    }
  }
}
.single-discount {
  min-width: 22px * @375;
  height: 18px * @375;
  padding: 0px * @375 4px * @375;
  padding-left: 24px * @375;
  color: #ffffff;
  font-weight: 400;

  font-size: 8px * @375;
  line-height: 18px * @375;
  text-align: right;
  background-image: url("../assets/imgs/12@2x.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  & > span {
    margin-left: 1px * @375;
  }
}
.not-tag {
  display: flex;
  margin-top: 2px * @375;
  margin-bottom: 2px * @375;
  & > span {
    font-size: 14px * @375;
    font-weight: 500;
    color: #000000;
    & > img {
      width: 11px * @375;
      height: 11px * @375;
      margin-right: 2px * @375;
    }
  }
  & > img {
    width: 18px * @375;
    height: 12px * @375;
    vertical-align: bottom;
  }
}
</style>
